module.exports = "https://coursera_assets.s3.amazonaws.com/images/53405f7f3dd342ada40d32c06bbe54ab.png";